module.exports = __webpack_public_path__ + "img/client-brief.59bce6cf.svg";